import { Button, Stack } from 'canoe';
import { Form, useFormikContext } from 'formik';
import React from 'react';

import AppendPlacementIconDark from '!!react-svg-loader!./assets/PageLoadDark.svg';
import { ContentPlacement, MODAL_TIME_FRAMES_TXT, ModalTimeFrames } from '@candu-ai/placement/types';
import { SelectCard } from '@candu-ai/placement/ui';
import {
  ActiveStepHeader,
  CardsContainer,
  CompletedStepSettings,
  EditLinkButton,
  StepCircle,
  StepSubtitle,
  StepTitle,
} from 'craft/containers/Toolbox/tabs/Placements/components/ui';

interface Props {
  active: boolean;
  onEdit: VoidFunction;
  onCancel: VoidFunction;
  onSave: VoidFunction;
  state: 'create' | 'update';
}

export const StepTwo = ({ active, onEdit, state, onCancel, onSave }: Props) => {
  const { values, setFieldValue, dirty } = useFormikContext<ContentPlacement>();

  if (active) {
    return (
      <div>
        <ActiveStepHeader center>
          <StepCircle>2</StepCircle>
          <StepTitle size="short" active>
            When will it be displayed?
          </StepTitle>
          <StepSubtitle>You can always change this later.</StepSubtitle>
        </ActiveStepHeader>

        <Form data-cy="form-placement">
          <Stack space="s">
            <CardsContainer>
              <SelectCard active type="button" mode="Dark">
                <AppendPlacementIconDark />
                On page load
              </SelectCard>
            </CardsContainer>
            <CardsContainer>
              <SelectCard
                active={values.showTimeframe === ModalTimeFrames.UNTIL_DISMISSED}
                onClick={() => setFieldValue('showTimeframe', ModalTimeFrames.UNTIL_DISMISSED)}
                size="normal"
                type="button"
                mode="Dark"
              >
                {MODAL_TIME_FRAMES_TXT.UntilDismissed}
              </SelectCard>
              <SelectCard
                active={values.showTimeframe === ModalTimeFrames.FOREVER}
                onClick={() => setFieldValue('showTimeframe', ModalTimeFrames.FOREVER)}
                size="normal"
                type="button"
                mode="Dark"
              >
                {MODAL_TIME_FRAMES_TXT.Forever}
              </SelectCard>
            </CardsContainer>
            <div>
              <Button
                variant="secondary"
                fullWidth
                disabled={state === 'update' && !dirty}
                onClick={onSave}
              >
                {state === 'create' ? 'Start Editing Content' : 'Update'}
              </Button>

              <Button variant="neutral" appearance="outline" fullWidth onClick={onCancel} mt="xs">
                Cancel
              </Button>
            </div>
          </Stack>
        </Form>
      </div>
    );
  }

  return (
    <div>
      <StepTitle size="short">2. When will it be displayed?</StepTitle>

      {!active || state === 'update' ? (
        <CompletedStepSettings>
          <Stack space="xs">
            <span>
              <strong>On page load</strong>
            </span>
            <span>
              <strong>
                {MODAL_TIME_FRAMES_TXT[values.showTimeframe || ModalTimeFrames.FOREVER]}
              </strong>
            </span>
          </Stack>
          <EditLinkButton
            appearance="text"
            inline
            size="small"
            variant="white"
            fontWeight="xbold"
            onClick={onEdit}
          >
            edit
          </EditLinkButton>
        </CompletedStepSettings>
      ) : (
        <Button variant="secondary" fullWidth disabled mt="s">
          Start Editing Content
        </Button>
      )}
    </div>
  );
};
